import { post } from "./AxiosMethods";

export default class Translation {

    static load(translationKeys) {
        return post("/api/translation/load", translationKeys);
    }
}
